export const environment = {
  production: false,
  local: false,
  serverUrl: 'https://papin2api.rrsolutionstest.it/',
  domain: 'https://papin2.rrsolutionstest.it/'
};
